var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 43,
    viewBox: "0 0 33 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62_2560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1605 13.3807V26.0904H24.5692V13.3807C24.5692 8.54699 20.8996 4.61727 16.3837 4.61727C11.8678 4.61727 8.19817 8.54699 8.19817 13.3807V26.0904H4.60694V13.3807C4.60281 6.46242 9.88646 0.832031 16.3796 0.832031C22.8727 0.832031 28.1563 6.46242 28.1563 13.3807H28.1605Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.60254 16.6875L8.19377 16.832V26.0907H4.60254V16.6875Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1601 17.6464V26.092H24.5688V17.502L28.1601 17.6464Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7628 18.8535H0V42.9932H32.7628V18.8535Z",
    fill: "#516CD3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32.7587 18.8535H16.3794V42.9932H32.7587V18.8535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.63 31.6706L18.8766 37.5899H13.5806L14.8272 31.6706C14.08 31.2 13.5806 30.3786 13.5806 29.4333C13.5806 27.9555 14.7694 26.7832 16.2306 26.7832C17.6919 26.7832 18.8807 27.9555 18.8807 29.4333C18.8807 30.3786 18.3771 31.2 17.6341 31.6706H17.63Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.72951 28.7733C1.25068 25.987 1.23417 23.1099 1.44469 20.2988C3.21141 20.3607 4.974 20.4474 6.74072 20.6208C5.07307 20.7859 3.40129 20.8726 1.73364 20.9345L2.04735 20.6208C2.09689 21.2978 2.12991 21.9789 2.13817 22.66C2.16706 24.6867 2.09689 26.7713 1.73777 28.7733H1.72951Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_2560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.7628,
    height: 42.166,
    fill: "white",
    transform: "translate(0 0.832031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/Padlock.c1a3f5832066c81cdb269763296b6065.svg";
export { ForwardRef as ReactComponent };